import { createSlice } from "@reduxjs/toolkit";
import { getImproveDeveloperExperienceData } from "../../../helpers/debuggerHelper";
import { LF_DEBUGGER } from "../../../config/constant/projectConstant";

const LS_LF_DEBUGGER_LOCAL_FILE_URLS = 'LF_DEBUGGER_LOCAL_FILE_URLS';
const LS_LF_DEBUGGER_BACKUP_POPUP_ENABLED = 'LF_DEBUGGER_BACKUP_POPUP_ENABLED';
export const LS_LF_DEBUGGER_CSG_OPERATION_ENABLED = 'LF_DEBUGGER_CSG_OPERATION_ENABLED';

const getInitialState = () => {
  const localFileUrlsActive = localStorage.getItem(LS_LF_DEBUGGER_LOCAL_FILE_URLS);
  const backupPopupEnabled = localStorage.getItem(LS_LF_DEBUGGER_BACKUP_POPUP_ENABLED) === 'true';
  const csgOperationEnabled = localStorage.getItem(LS_LF_DEBUGGER_CSG_OPERATION_ENABLED);

  const searchParams = new URLSearchParams(window.location.search);

  return {
    active: searchParams.get(LF_DEBUGGER) === '1', // represents if debugger is active in curent window or not
    open: searchParams.get(LF_DEBUGGER) === '1',
    localFileUrlsActive: localFileUrlsActive === 'false' ? false : true,
    initialPropList: [],
    initialMaterialDataList: [],
    autoFocusActive: true,
    backupPopupEnabled: getImproveDeveloperExperienceData(backupPopupEnabled, true),
    csgOperationEnabled: (csgOperationEnabled === 'false' || csgOperationEnabled === false) ? false : true,
  }
}

const curatorDebuggerSlicer = createSlice({
  name: "curatorDebugger",
  initialState:  getInitialState(),
  // {
  //   localFileUrlsActive: Boolean(), // do we want to use local file urls from indexdb or file urls returned by the backend
  // },
  reducers: {
    setOpen: (state, { payload }) => {
      state.open = payload;
    },
    setLocalFileUrlsActive: (state, { payload }) => {
      state.localFileUrlsActive = payload;
      localStorage.setItem(LS_LF_DEBUGGER_LOCAL_FILE_URLS, payload)
    },
    setInitialPropList: (state, { payload }) => {
      state.initialPropList = payload;
    },
    setInitialMaterialDataList: (state, { payload }) => {
      state.initialMaterialDataList = payload;
    },
    setCuratorDebuggerActive: (state, { payload }) => {
      state.active = payload;
    },
    setAutoFocusActive: (state, { payload }) => {
      state.autoFocusActive = payload
    },
    toggleBackupPopupEnabled: (state) => {
      const newState = !state.backupPopupEnabled;
      state.backupPopupEnabled = newState;
      localStorage.setItem(LS_LF_DEBUGGER_BACKUP_POPUP_ENABLED, newState);
    },
    toggleCSGOperationPopupEnabled: (state) => {
      const newState = !state.csgOperationEnabled;
      state.csgOperationEnabled = newState;
      localStorage.setItem(LS_LF_DEBUGGER_CSG_OPERATION_ENABLED, newState);
    },
  },
});

export const {
  setLocalFileUrlsActive,
  setAutoFocusActive,
  toggleBackupPopupEnabled,
  toggleCSGOperationPopupEnabled,
} = curatorDebuggerSlicer.actions;
export const curatorDebuggerActions = curatorDebuggerSlicer.actions;

export const curatorDebuggerReducer = curatorDebuggerSlicer.reducer;

export const selectLocalFileUrlsActive = (state) => state.curatorDebugger.localFileUrlsActive;
export const selectCuratorDebuggerActive = (state) => state.curatorDebugger.active;
export const selectCuratorDebuggerOpen = (state) => state.curatorDebugger.open;
export const selectInitialPropList = (state) => state.curatorDebugger.initialPropList;
export const selectInitialMaterialDataList = (state) => state.curatorDebugger.initialMaterialDataList;
export const selectAutoFocusActive = (state) => state.curatorDebugger.autoFocusActive;
export const selectBackupPopupEnabled = (state) => state.curatorDebugger.backupPopupEnabled;
export const selectCSGOperationPopupEnabled = (state) => state.curatorDebugger.csgOperationEnabled;